import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

const JEA_YEAR = 2021;

export const defaultState = {
  jea2021: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  JEA2021_SET_LIST(state, list) {
    state.jea2021.list = list;
  },
  JEA2021_SET_LIST_LOADING(state, isLoading) {
    state.jea2021.listLoading = isLoading;
  },
};

export const getters = {
  getJea2021List: state => state.jea2021.list,
  getJea2021ListIsLoading: state => state.jea2021.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callJea2021Approve({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/approve`, data)
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callJea2021Trigger({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/trigger`, data)
      .then(result => result.data);
  },
  fetchJea2021List({ commit }, filterByStatus) {
    commit('JEA2021_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea?filter_by_status=${filterByStatus}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { jeas } = response;
          commit('JEA2021_SET_LIST_LOADING', false);
          commit('JEA2021_SET_LIST', jeas);
        });
      })
      .catch((error) => {
        commit('JEA2021_SET_LIST_LOADING', false);
        commit('JEA2021_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchJea2021All({ dispatch }, filterByStatus) {
    dispatch('fetchJea2021List', filterByStatus);
  },
  // eslint-disable-next-line no-unused-vars
  fetchJea2021DownloadPdf({ commit }, requestData) {
    const { id } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/pdf/${id}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const jea2021 = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default jea2021;



// WEBPACK FOOTER //
// ./src/store/payout/jea2021.js